import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/restore.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleEventRestoredEvent } from './Types'
import { displayDateTime } from 'utils/dates'

interface Props extends ActivityEventPosition {
  event: ArticleEventRestoredEvent
}

const ArticleEventRestored = ({ event, ...props }: Props) => {
  const {
    user,
    data: {
      restored_event: { timestamp, name },
    },
  } = event

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> restored a previous state from
          "{name || displayDateTime(timestamp)}"
        </>
      }
    />
  )
}

export { ArticleEventRestored }
